import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";

//Componentes
import OrderList from "./OrderList";
import BuyAgain from "./BuyAgain/BuyAgain";
import InactiveOrderList from "./Abandoned/AbandonedOrder";

import { uiUserOrdersTab } from "../../../actions/ui";
import { loadMoreOrders, myOrders } from "../../../actions/user-account";
import { getMyReviewSummary } from "../../../actions/review";

//CSS
import './pedidos.css';

//MUI
import {
    Alert, Box, Button, Container, Tab, Typography,
    Breadcrumbs, useMediaQuery
} from '@mui/material';
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { styled } from '@mui/material/styles';

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
    ({ theme }) => ({
        textTransform: 'none',
        fontSize: '15px',
        marginRight: '8px',
    })
);

const PedidosComponent = () => {
    const dispatch = useDispatch();
    const matches = useMediaQuery('(max-width: 950px)');

    // datos de usuario iniciado
    const { loggedUser: { email } } = useSelector(state => state.user);
    const { user_account: { userOrdersTab } } = useSelector(state => state.ui);
    // pedidos
    const { orders, inactive_orders } = useSelector(state => state.user_account);

    // carga de pedidos
    const [loading, setLoading] = useState({
        _screen: true, _button: false
    });
    // omitir pedidos
    const [pageSkip, setPageSkip] = useState({
        approved_skip: 0, inactive_skip: 0
    });
    const [pendingReviews, setPendingReviews] = useState(null);
    const { approved_skip, inactive_skip } = pageSkip;

    useEffect(() => {
        setPageSkip(e => ({
            ...e, approved_skip: orders.length,
            inactive_skip: inactive_orders.length
        }));
    }, [orders, inactive_orders]);
    
    useEffect(() => {
        let isMounted = true;

        // llevar operaciones solo si sigue montado
        const safeSetLoading = (fn) => {
            if (isMounted) setLoading(fn);
        };
        if (email)
            dispatch(myOrders(safeSetLoading));

        return () => {
            isMounted = false;
        };
    }, [email]);

    useEffect(() => {
        let mounted = true;

        const loadReviewSummary = async () => {
            try {
                const body = await getMyReviewSummary();

                if (mounted && body.status)
                    setPendingReviews(body.resp.pending);
            } catch (error) {
                if (mounted)
                    setPendingReviews(null);
            }
        };

        if (email)
            loadReviewSummary();

        return () => {
            mounted = false;
        };
    }, [email]);
    
    const handleChange = (event, newValue) => {
        dispatch(uiUserOrdersTab(newValue));
    };

    const getMoreOrders = flag => () => {
        setLoading(e => ({ ...e, _button: true }));
        dispatch(loadMoreOrders(flag, pageSkip, setLoading));
    };

    return (
        <>
            <Container maxWidth='xl' sx={{ mt: matches ? 5 : 18 }}>
                <Breadcrumbs aria-label="user breadcrumb" sx={{ mb: 2 }}>
                    <Link underline="hover" color="inherit" to="/mi-cuenta">
                        Mi cuenta
                    </Link>
                    <Typography color="text.primary">Mis pedidos</Typography>
                </Breadcrumbs>
                <Typography variant='h4' sx={{ fontWeight: 'light' }}>Mis pedidos</Typography>
            </Container>

            <Container maxWidth='xl' sx={{ mt: 3 }} className="last-view">
                {pendingReviews > 0 &&
                    <Alert
                        severity="info"
                        action={
                            <Button
                                color="inherit"
                                component={Link}
                                size="small"
                                to="/mi-cuenta/mis-resenas"
                            >
                                Ver pendientes
                            </Button>
                        }
                        sx={{ mb: 2 }}
                    >
                        Tienes {pendingReviews} {
                            pendingReviews === 1 ? 'producto' : 'productos'
                        } pendiente{pendingReviews === 1 ? '' : 's'} por reseñar.
                    </Alert>
                }
                <TabContext value={ userOrdersTab } variant="scrollable" scrollButtons="auto">
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={ handleChange } aria-label="user orders tab">
                            <StyledTab label="Aprobados" value="1" />
                            <StyledTab label="Comprados recientemente" value="2" />
                            <StyledTab label="Inactivos" value="3" />
                        </TabList>
                    </Box>
                    {/* Pedidos */}
                    <TabPanel value="1" sx={{ px: 0 }}>
                        <OrderList
                            loading={ loading }
                            approved_skip={ approved_skip }
                            getMoreOrders={ getMoreOrders }
                        />
                    </TabPanel>

                    {/* Comprar nuevamente */}
                    <TabPanel value="2" sx={{ px: 0 }}>
                        <BuyAgain />
                    </TabPanel>

                    <TabPanel value="3" sx={{ px: 0 }}>
                        <InactiveOrderList
                            loading={ loading }
                            inactive_skip={ inactive_skip }
                            getMoreOrders={ getMoreOrders }
                        />
                    </TabPanel>
                </TabContext>
            </Container>
        </>
    );
};

export default PedidosComponent;
